import { combineActions, handleActions } from 'redux-actions';
import * as conversationActions from '../../../components/conversation/actions/conversation';
const { conversationWsOfferReceived, conversationRespondeToOfferAccepted, conversationRespondeToOfferRejected, conversationWsTransferOfferReceived, conversationRespondeToTransferOfferAccepted, conversationRespondeToTransferOfferRejected, conversationWsOfferCanceled, } = conversationActions.actions;
const initialState = {
    conversationOffers: [],
};
// Reducer
const offers = handleActions({
    [combineActions(conversationWsOfferReceived.toString(), conversationWsTransferOfferReceived.toString())]: (state, action) => {
        const conversationOffers = state.conversationOffers.slice();
        if (action.payload && action.payload.params) {
            const reassignment = action.payload.params.reassignment === true;
            const transferType = action.payload.params.transfer_type
                ? action.payload.params.transfer_type
                : null;
            const isInternal = action.payload.params.direction === 'internal';
            conversationOffers.push({
                csid: action.payload.params.csid,
                reassignment: reassignment,
                isInternal: isInternal,
                transferType: transferType,
            });
        }
        return Object.assign(Object.assign({}, state), { conversationOffers: conversationOffers });
    },
    [combineActions(conversationRespondeToOfferAccepted.toString(), conversationRespondeToOfferRejected.toString(), conversationRespondeToTransferOfferAccepted.toString(), conversationRespondeToTransferOfferRejected.toString(), conversationWsOfferCanceled.toString())]: (state, action) => {
        const conversationOffers = state.conversationOffers.slice();
        let csid = null;
        if (action.payload &&
            action.payload.params &&
            action.payload.params.csid) {
            csid = action.payload.params.csid;
        }
        else if (action.payload.csid) {
            csid = action.payload.csid;
        }
        const foundIndex = conversationOffers.findIndex((offer) => offer.csid === csid);
        if (foundIndex > -1) {
            conversationOffers.splice(foundIndex, 1);
        }
        return Object.assign(Object.assign({}, state), { conversationOffers: conversationOffers });
    },
}, initialState);
export default offers;
